import React from "react";
import { useScrollReveal, useCountUp } from "./useAnimations";
import "./TrustBar.scss";

const stats = [
  { number: 100, suffix: "+", label: "Projects Delivered" },
  { number: 98, suffix: "%", label: "Client Retention" },
  { number: 10, suffix: "+", label: "Years of Excellence" },
  { number: 15, suffix: "+", label: "Industry Verticals" },
];

const StatItem = ({ stat, isActive, delay }) => {
  const count = useCountUp(stat.number, 2000, isActive);
  return (
    <div
      className={`about__stat${isActive ? " is-visible" : ""}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <span className="about__stat-number">
        {count}
        <span className="about__stat-suffix">{stat.suffix}</span>
      </span>
      <span className="about__stat-label">{stat.label}</span>
    </div>
  );
};

const TrustBar = () => {
  const [hRef, hVis] = useScrollReveal();
  const [sRef, sVis] = useScrollReveal({ threshold: 0.2 });
  const [dRef, dVis] = useScrollReveal();
  const [imgRef, imgVis] = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="about">
      <div className="about__inner">
        <div className="about__top-row">
          <div ref={hRef} className="about__top">
            <span className={`about__label${hVis ? " is-visible" : ""}`}>
              Trusted By Enterprises That Cannot Afford to Get It Wrong
            </span>
            <h2 className={`about__title${hVis ? " is-visible" : ""}`}>
              Big 4 Standards.
              <br />
              Built for the AI Era.
            </h2>
          </div>

          <div
            ref={imgRef}
            className={`about__img${imgVis ? " is-visible" : ""}`}
          >
            <img
              src="https://images.unsplash.com/photo-1553028826-f4804a6dba3b?auto=format&fit=crop&w=560&q=80"
              alt="Enterprise office environment"
              loading="lazy"
            />
          </div>
        </div>

        <div ref={dRef} className="about__text-row">
          <p className={`about__text${dVis ? " is-visible" : ""}`}>
            From NHS digital programmes to CERN&#8217;s data infrastructure,
            Channel 4&#8217;s engineering teams and ARUP&#8217;s enterprise
            platforms - we work where the stakes are high, governance matters
            and delivery cannot slip.
          </p>
          <p
            className={`about__text about__text--right${
              dVis ? " is-visible" : ""
            }`}
          >
            digiRyte combines the rigour of a major consultancy with the speed
            of an AI-native engineering firm. No inflated teams. No team-heavy
            delivery model. No strategy that stops at slides.
          </p>
        </div>

        <div ref={sRef} className="about__stats">
          {stats.map((s, i) => (
            <StatItem key={i} stat={s} isActive={sVis} delay={i * 0.12} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
